<template>
  <div class="dropdown" style="float:left;">
    <button class="dropbtn attendance-dropdown">
      <p>{{ active == null ? 'All' : texts[active]  }}&nbsp;<i class="fas fa-caret-down"></i></p>
    </button>
    <div class="dropdown-content">
      <a href="#" @click="filter(null)">All</a>
      <a href="#" @click="filter(1)">Active</a>
      <a href="#" @click="filter(0)">Inactive</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ActiveFilter',
    props: {
      active: {
        default: 1
      }
    },
    data() {
      return {
        texts: ['Inactive', 'Active']
      }
    },
    methods: {
      filter(value) {
        this.$emit('status', value);
      }
    }
  }
</script>
